import { Component, OnInit } from '@angular/core';
import { VeiculosClvService } from './veiculos-clv.service';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import * as textMask from 'vanilla-text-mask';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { RmpvDetalhadoListaComponent } from '../../rmpv/rmpv-detalhado/rmpv-detalhado-lista/rmpv-detalhado-lista.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RmpvDetalhadoService } from '../../rmpv/rmpv-detalhado/rmpv-detalhado.service';
import { RankingCliente } from './ranking-cliente.model';
import { formatarDocumentoCliente, formatarTipoCliente, formatarTotalGasto } from './clv-ranking-formatacao';
import { ServiceAppService } from '../../../security/service-app.service';

registerLocaleData(localePt, 'pt-BR');

@Component({
  selector: 'app-veiculos-clv',
  templateUrl: './veiculos-clv.component.html',
  styleUrls: ['./veiculos-clv.component.scss'],
  providers: [VeiculosClvService],
})

export class VeiculosClvComponent implements OnInit {
  valorDados: any[] = [];
  valorSegundaTabela: any[] = [];
  valorDadosBaixo: any[] = [];
  columns: string[] = [];
  getValuePercent: string[] = []
  loading: boolean = false;
  cpfCnpj: any;
  chassi: string = '';
  dataInc: Date;
  dataFim: Date;
  mostrarCaption: boolean = false;
  ref: DynamicDialogRef;
  disabled: boolean = true;
  nomeCliente: any;
  retiraHeader: boolean = true;
  percentuais: any[] = [];
  valorCpfRecebe: any;
  valorCpfRetorno: any;
  valorChassi: any;
  valorDataIncRetorno: any;
  valorDataFimRetorno: any;
  totalGeral: any;
  totalKmGeral: any;
  form: FormGroup;
  retiraMascaraCpf: number;
  primeiraPesquisa: boolean = true;
  exibirLucroPrevisto: boolean = false;
  private marcaCarregada: boolean = false;
  ranking: RankingCliente[] = [];
  rankingCarregando: boolean = false;
  rankingErro: boolean = false;
  exibirModalExportacao: boolean = false;
  quantidadePorModelo: { [modelo: string]: number } = {};

  constructor(
    private veiculosClvService: VeiculosClvService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private fb: FormBuilder,
    private rmpvService: RmpvDetalhadoService,
    private serviceApp: ServiceAppService,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      cpf: [''],
      chassi: [''],
      dataInc: [null],
      dataFim: [null],
    });
    const today = new Date();
    this.dataFim = today;
    this.nomeCliente = '';
    this.dataInc = new Date(2012, 0, 1);
    this.veiculosClvService.getPercentuais().subscribe((data) => {
      this.percentuais = data;
    });
    this.carregarRanking();
    this.carregarMarca(() => this.retornaDadosTelaAnterior());
  }

  private carregarMarca(aoConcluir?: () => void): void {
    if (this.marcaCarregada) {
      if (aoConcluir) {
        aoConcluir();
      }
      return;
    }

    this.serviceApp.getDados('/admin/capturarMarca').subscribe(
      (res) => {
        const marca = res && res.nome ? String(res.nome).toUpperCase() : '';
        this.exibirLucroPrevisto = marca.includes('TRIUMPH');
        this.marcaCarregada = true;
        if (aoConcluir) {
          aoConcluir();
        }
      },
      () => {
        this.exibirLucroPrevisto = false;
        this.marcaCarregada = true;
        if (aoConcluir) {
          aoConcluir();
        }
      }
    );
  }

  carregarRanking(): void {
    this.rankingCarregando = true;
    this.rankingErro = false;
    this.veiculosClvService.getRanking().subscribe(
      (data) => {
        this.ranking = Array.isArray(data) ? data : [];
        this.rankingCarregando = false;
      },
      () => {
        this.ranking = [];
        this.rankingErro = true;
        this.rankingCarregando = false;
        this.messageService.add({
          key: 'tl',
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao buscar o ranking de clientes.',
          life: 3000,
        });
      }
    );
  }

  formatarTipoRanking(tipo: string): string {
    return formatarTipoCliente(tipo);
  }

  formatarDocumentoRanking(documento: string, tipo: string): string {
    return formatarDocumentoCliente(documento, tipo);
  }

  formatarTotalRanking(valor: number): string {
    return formatarTotalGasto(valor);
  }

  private preencherLucroPrevisto(data: any[]): void {
    if (this.exibirLucroPrevisto) {
      this.segundaTable(data);
    } else {
      this.valorSegundaTabela = [];
    }
  }

  limpar() {
    this.cpfCnpj = null;
    this.chassi = null;
    this.valorDados = [];
    this.totalGeral = 0;
    this.totalKmGeral = 0;
    this.valorSegundaTabela = [];
    this.valorDadosBaixo = [];
    this.columns = [];
    this.quantidadePorModelo = {};
    this.mostrarCaption = false;
    this.nomeCliente = '';
    this.loading = false;
  }


  clickBuscar() {
    this.valuePorcentagem();
    if (!this.cpfCnpj && !this.chassi) {
      this.messageService.add({
        key: 'tl',
        severity: 'error',
        summary: 'Aviso',
        detail: 'Informe pelo menos o CPF/CNPJ ou CHASSI.',
        life: 5000,
      });
      return;
    }

    const cpfCnpjLimpo = this.removerMascara(this.cpfCnpj);
    const dataIncFormatada = this.dataInc ? this.formatDate(this.dataInc) : '';
    const dataFimFormatada = this.dataFim ? this.formatDate(this.dataFim) : '';
    const retiraaMascaraCpf = cpfCnpjLimpo.replace(/^0+/, '');
    this.totalGeral = 0;
    this.totalKmGeral = 0;
    this.loading = true;
    if (this.primeiraPesquisa) {
      this.mostrarCaption = true;
    } else {
      this.mostrarCaption = true;
    }

    this.veiculosClvService.getDados(dataIncFormatada, dataFimFormatada, this.chassi, retiraaMascaraCpf)
      .subscribe(
        (data) => {
          if (!data || data.length === 0) {
            this.messageService.add({
              key: 'tl',
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Não foram localizados dados para este CPF/CNPJ ou Chassi',
              life: 3000,
            });
            this.mostrarCaption = false;
            this.valorDados = [];
            this.valorSegundaTabela = [];
            this.valorDadosBaixo = [];
            this.columns = [];
            this.quantidadePorModelo = {};
            this.nomeCliente = '';
          } else {
            data.forEach(item => {
              item.chassiFormatado = this.chassi ? `CHASSI: ${this.chassi}` : '';
            });
            this.nomeCliente = data[0].dados[0].nome || '';
            this.carregarMarca(() => {
              this.primeiraTable(data);
              this.preencherLucroPrevisto(data);
              this.formatDataGridBaixo(data);
              this.mostrarCaption = true;
            });
          }
          this.primeiraPesquisa = false;
        },
        (error) => {
          this.messageService.add({
            key: 'tl',
            severity: 'error',
            summary: 'Erro',
            detail: 'Ocorreu um erro ao buscar os dados.',
            life: 3000,
          });
          this.nomeCliente = '';
        },
        () => {
          this.loading = false;
        }
      );
  }

  private primeiraTable(data: any[]) {
    const linhaChassi: any = { ITEM: 'Chassi' };
    this.quantidadePorModelo = {};
    data.forEach((item) => {
      linhaChassi[item.veiculo_descricao] = item.dados[0].Chassi;
      this.quantidadePorModelo[item.veiculo_descricao] = this.contarVeiculosDoModelo(item);
    });
    const camposFixos = [
      'Preço Venda',
      'Acessórios',
      'Roupas',
      'Seguro',
      'Consórcio',
      'TRX',
      '1a Revisão (6 meses/1000km)',
      'Revisão anual',
      '2a Revisão (10.000/16.000km por ano)',
      '3a Revisão (20.000/32.000 em 2 anos)',
      'Lavagem',
      '1a. Troca de Pastilhas (10.000km/Tras.)',
      '2a. Troca de Pastilhas (20.000km)',
      'Garantia Estendida',
      'TOTAL',
    ];
    const camposOcultosForaTriumph = [
      '1a Revisão (6 meses/1000km)',
      '2a Revisão (10.000/16.000km por ano)',
      '3a Revisão (20.000/32.000 em 2 anos)',
      '1a. Troca de Pastilhas (10.000km/Tras.)',
      '2a. Troca de Pastilhas (20.000km)',
    ];
    const camposExibidos = this.exibirLucroPrevisto
      ? camposFixos
      : camposFixos.filter((field) => !camposOcultosForaTriumph.includes(field));

    const mapeandoCampos = {
      'Preço Venda': 'precovenda',
      'Acessórios': 'acessorios',
      'Roupas': 'roupas',
      'Seguro': 'seguro',
      'Consórcio': 'consorcio',
      'TRX': 'trx',
      '1a Revisão (6 meses/1000km)': 'primeirarevisao',
      'Revisão anual': 'revisaoanual',
      '2a Revisão (10.000/16.000km por ano)': 'segundarevisao',
      '3a Revisão (20.000/32.000 em 2 anos)': 'terceirarevisao',
      'Lavagem': 'lavagem',
      '1a. Troca de Pastilhas (10.000km/Tras.)': 'primeiratrocapastilha',
      '2a. Troca de Pastilhas (20.000km)': 'segundatrocapastilha',
      'Garantia Estendida': 'garantiaestendida',
      'TOTAL': 'total',
    };
    const linhasDados = [
      linhaChassi,
      ...camposExibidos.map((field) => {
        const row: any = { ITEM: field };
        data.forEach((item) => {
          const key = mapeandoCampos[field];
          row[item.veiculo_descricao] = key ? this.formatCurrency(item.dados[0][key]) : null;
        });
        return row;
      }),
    ];
    this.valorDados = linhasDados;
    this.columns = ['ITEM', ...data.map((item) => item.veiculo_descricao)];
  }

  private contarVeiculosDoModelo(item: any): number {
    const dados = item && item.dados && item.dados[0];
    if (!dados) {
      return 0;
    }
    if (Array.isArray(dados.Chassis)) {
      return dados.Chassis.length;
    }
    const qtd = Number(dados.QtdMotosCompradas);
    if (dados.QtdMotosCompradas !== null && dados.QtdMotosCompradas !== undefined && dados.QtdMotosCompradas !== '' && !isNaN(qtd)) {
      return qtd;
    }
    return dados.Chassi ? 1 : 0;
  }

  public doSearch(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.clickBuscar();
    }
  }

  private removerMascara(valor: string): string {
    if (!valor) return '';
    return valor.replace(/\D/g, '');
  }


  public validaFocus() {
    if (this.cpfCnpj) {
      const verificaTipoValor = this.cpfCnpj.replace(/\D/g, '');

      if (verificaTipoValor.length === 11) {
        this.cpfCnpj = this.aplicarMascara(verificaTipoValor, '999.999.999-99');
      } else if (verificaTipoValor.length < 11) {
        const valorFormatado = verificaTipoValor.padStart(11, '0');
        this.cpfCnpj = this.aplicarMascara(valorFormatado, '999.999.999-99');
      }
      else if (verificaTipoValor.length < 14 || verificaTipoValor.length > 11) {
        const valorFormatadoCnpj = verificaTipoValor.padStart(14, '0');
        this.cpfCnpj = this.aplicarMascara(valorFormatadoCnpj, '99.999.999/9999-99');
      } else {
        this.messageService.add({
          key: 'tl',
          severity: 'warn',
          summary: 'Aviso',
          detail: 'CPF ou CNPJ inválido.',
          life: 3000,
        });
        this.cpfCnpj = verificaTipoValor;
      }
    }
  }

  private aplicarMascara(valor: string, mascara: string): string {
    const maskArray = mascara.split('').map((char) => (char === '9' ? /\d/ : char));
    const maskedValue = textMask.conformToMask(valor, maskArray, { guide: false });
    return maskedValue.conformedValue;
  }

  private formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  redirecionaRelatorioVeiculos(event: any) {
    const valorDataInc = this.formatDate(this.dataInc);
    const valorDataFim = this.formatDate(this.dataFim);
    const valorCpf = this.cpfCnpj;

    this.router.navigate(['/veiculo/vendido'], {
      queryParams: {
        cpf: valorCpf,
        modelo: event,
        dataInicial: valorDataInc,
        dataFinal: valorDataFim
      }
    });
  }

  redirecionaRmpvDetalhado(column: any, row: any) {
    this.ref = this.dialogService.open(RmpvDetalhadoListaComponent, {
      data: this.modalRmpvDetalhado(column),
      header: 'RMPV - Detalhado',
      width: window.innerWidth >= 720 ? '90%' : '100%',
      height: window.innerWidth <= 720 ? '60%' : '94%',
      baseZIndex: 10000,
      styleClass: 'icon-modal-filtros-avancados',
      footer: ' ',
      contentStyle: { overflow: 'auto' },
    });

    this.ref.onClose.subscribe((dados: any) => {
      console.log(dados);
    });
  }


  modalRmpvDetalhado(column: any) {
    const linhaChassi = this.valorDados.find((row: any) => row['ITEM'] === 'Chassi');

    if (linhaChassi) {
      const chassiModelos = Object.keys(linhaChassi)
        .filter((key) => key !== 'ITEM')
        .map((key) => ({
          modelo: key,
          chassi: linhaChassi[key]
        }));

      const chassiSelecionado = chassiModelos.find(modelo => modelo.modelo === column)?.chassi;

      const valorDataInc = this.formatDate(this.dataInc);
      const valorDataFim = this.formatDate(this.dataFim);

      const objetoFinal = {
        chassi: chassiSelecionado,
        dataInicial: valorDataInc,
        dataFinal: valorDataFim,
      };

      this.rmpvService.atualizarModal(objetoFinal);

      return objetoFinal;
    } else {
      console.warn('chassi não encontrado');
      return {};
    }
  }

  recebeFiltro() {
    this.veiculosClvService.valorModal$.subscribe(componente => {
      if (componente != null) {
        this.chassi = componente.chassi;
        this.dataInc = componente.dataInicial;
        this.dataFim = componente.dataFinal;
        this.f.chassi.setValue(this.chassi);
        this.clickBuscar();
      }
    });
  }


  get f() {
    return this.form ? this.form.controls : {};
  }


  public recebeParametroRetorno() {
    this.route.queryParams.subscribe(params => {
      const valorCpfRetorno = params.cpf;
      const valorChassi = params.chassi;
      const valorDataIncRetorno = params.dataInicial;
      const valorDataFimRetorno = params.dataFinal;

      const cpfCnpjLimpo = this.removerMascara(valorCpfRetorno);

      this.f.cpf.setValue(cpfCnpjLimpo);
      this.f.chassi.setValue(valorChassi);
      this.f.dataInc.setValue(valorDataIncRetorno);
      this.f.dataFim.setValue(valorDataFimRetorno);

      this.clickBuscar();
    });
  }






  obterUrlComFiltros(): string {
    let url = '';
    return 'veiculo/vendido' + url;
  }

  segundaTable(data: any[]): void {
    const camposFixos = [
      'Venda Veículo Novo',
      'Acessórios',
      'Roupas',
      'Seguro',
      'Consórcio',
      'TRX',
      '1a Revisão',
      'Revisão anual',
      '2a Revisão',
      '3a Revisão',
      'Lavagem',
      '1a. Troca de Pastilhas',
      '2a. Troca de Pastilhas',
      'Garantia Estendida',
      'TOTAL',
    ];

    const mapeandoCampos = {
      'Venda Veículo Novo': 'vendamotonova',
      'Acessórios': 'acessorioskm',
      'Roupas': 'roupakm',
      'Seguro': 'segurokm',
      'Consórcio': 'consorciokm',
      'TRX': 'trxkm',
      '1a Revisão': 'primeirarevisaokm',
      'Revisão anual': 'revisaoanualkm',
      '2a Revisão': 'segundarevisaokm',
      '3a Revisão': 'terceirarevisaokm',
      'Lavagem': 'lavagemkm',
      '1a. Troca de Pastilhas': 'primeiratrocapastilhakm',
      '2a. Troca de Pastilhas': 'segundatrocapastilhakm',
      'Garantia Estendida': 'garantiaestendidakm',
      'TOTAL': 'totalkm',
    };

    this.valorSegundaTabela = camposFixos.map((field) => {
      const row: any = { ITEM: field };
      data.forEach((item) => {
        const key = mapeandoCampos[field];
        row[item.veiculo_descricao] = key ? this.formatCurrency(item.dados[0][key]) : null;
      });
      return row;
    });

    this.columns = ['ITEM', ...data.map((item) => item.veiculo_descricao)];
  }


  private formatCurrency(value: any): string {
    if (value == null || isNaN(value)) return '0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  private formatDataGridBaixo(data: any[]) {
    const camposFixosBaixo = [
      'Qtde Motos Novas Compradas',
      'Retenção Pós-Venda',
      'CUSTOMER VALUE ATÉ ANO 3',
    ];

    const mapeandoCamposBaixo = {
      'Qtde Motos Novas Compradas': 'QtdMotosCompradas',
      'Retenção Pós-Venda': 'retencaoPosVenda',
      'CUSTOMER VALUE ATÉ ANO 3': 'CustomerValue',
    };

    this.valorDadosBaixo = camposFixosBaixo.map((field) => {
      const row: any = { ITEM: field };

      data.forEach((item) => {
        const key = mapeandoCamposBaixo[field];
        if (key) {
          if (field === 'Retenção Pós-Venda') {
            row[item.veiculo_descricao] = `${item.dados[0][key] || 0}%`;
          } else if (field === 'CUSTOMER VALUE ATÉ ANO 3') {
            row[item.veiculo_descricao] = this.formatCurrency(item.dados[0][key] || 0);
          } else {
            row[item.veiculo_descricao] = item.dados[0][key] || 0;
          }
        }
      });

      return row;
    });

    this.totalGeral = data[0]?.dados[0]?.totalGeral || 0;
    this.totalKmGeral = data[0]?.dados[0]?.totalKmGeral || 0;

    this.columns = ['ITEM', ...data.map((item) => item.veiculo_descricao)];

    if (this.valorDadosBaixo.length === 0) {
      this.mostrarCaption = false;
    } else {
      this.mostrarCaption = true;
    }
  }


  private valuePorcentagem() {
    this.veiculosClvService.getPercentuais().subscribe(
      (data) => {
        this.getValuePercent = data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  isCurrencyColumn(column: string): boolean {
    const currencyColumns = [
      'Preço Venda',
      'Acessórios',
      'Roupas',
      'Seguro',
      'Consórcio',
      'TRX',
      '1a Revisão',
      'Revisão anual',
      '2a Revisão',
      '3a Revisão',
      'Lavagem',
      '1a. Troca de Pastilhas',
      '2a. Troca de Pastilhas',
      'Garantia Estendida',
      'TOTAL',
      '1a Revisão (6 meses/1000km)',
      '2a Revisão (10.000/16.000km por ano)',
      '3a Revisão (20.000/32.000 em 2 anos)',
      '1a. Troca de Pastilhas (10.000km/Tras.)',
      '2a. Troca de Pastilhas (20.000km)',
    ];
    return currencyColumns.includes(column);
  }

  isCurrencyColumnSecond(column: string): boolean {
    const currencyColumns = [
      'Venda Veículo Novo',
      'Acessórios',
      'Roupas',
      'Seguro',
      'Consórcio',
      'TRX',
      '1a Revisão',
      'Revisão anual',
      '2a Revisão',
      '3a Revisão',
      'Lavagem',
      '1a. Troca de Pastilhas',
      '2a. Troca de Pastilhas',
      'Garantia Estendida',
      'TOTAL',
    ];
    return currencyColumns.includes(column);
  }

  isCurrencyColumnThrid(column: string): boolean {
    const currencyColumns = [
      'CUSTOMER VALUE ATÉ ANO 3',
    ];
    return currencyColumns.includes(column);
  }

  public abrirExportacaoExcel(): void {
    if (!this.temDadosCliente()) {
      this.exportarExcel('ranking');
      return;
    }
    this.exibirModalExportacao = true;
  }

  public confirmarExportacao(tipo: 'ranking' | 'cliente' | 'ambos'): void {
    this.exibirModalExportacao = false;
    this.exportarExcel(tipo);
  }

  private temDadosCliente(): boolean {
    return this.mostrarCaption && (
      this.valorDados.length > 0 ||
      this.valorDadosBaixo.length > 0 ||
      this.valorSegundaTabela.length > 0
    );
  }

  private exportarExcel(tipo: 'ranking' | 'cliente' | 'ambos'): void {
    const incluirCliente = tipo === 'cliente' || tipo === 'ambos';
    const incluirRanking = tipo === 'ranking' || tipo === 'ambos';
    const temCliente = this.temDadosCliente();
    const temRanking = this.ranking.length > 0;

    if ((incluirCliente && !temCliente && !incluirRanking) ||
      (incluirRanking && !temRanking && !incluirCliente) ||
      (!temCliente && !temRanking)) {
      this.messageService.add({
        key: 'tl',
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não há dados para exportar.',
        life: 3000,
      });
      return;
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    if (incluirCliente && temCliente) {
      const dadosCliente = this.montarDadosCliente();
      const wsCliente: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dadosCliente);
      if (incluirRanking && temRanking) {
        XLSX.utils.sheet_add_aoa(wsCliente, this.linhasRanking(), { origin: dadosCliente.length + 1 });
      }
      XLSX.utils.book_append_sheet(wb, wsCliente, 'Customer Life Value (CLV)');
    } else if (incluirRanking && temRanking) {
      const wsRanking: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.linhasRanking());
      XLSX.utils.book_append_sheet(wb, wsRanking, 'Maiores clientes');
    }

    XLSX.writeFile(wb, 'Customer Lifetime Value (CLV).xlsx');

    if (incluirRanking && !temRanking && temCliente) {
      this.messageService.add({
        key: 'tl',
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O ranking não está disponível. O arquivo foi gerado só com os dados do cliente.',
        life: 3000,
      });
      return;
    }

    this.messageService.add({
      key: 'tl',
      severity: 'success',
      summary: 'Exportação',
      detail: 'Arquivo exportado com sucesso!',
      life: 3000,
    });
  }

  private montarDadosCliente(): any[] {
    const dadosExcel: any[] = [];
    const nomeClienteFormatado = this.nomeCliente ? `Cliente: ${this.nomeCliente}` : 'Nome do Cliente Não Informado';
    dadosExcel.push({ ITEM: nomeClienteFormatado });

    dadosExcel.push({});

    dadosExcel.push({ ITEM: 'Análise de Vendas no Período' });
    if (this.valorDados.length) {
      this.valorDados.forEach((row) => {
        const formattedRow = { ...row };
        Object.keys(row).forEach((key) => {
          if (this.isCurrencyColumn(key)) {
            formattedRow[key] = this.formatCurrency(row[key]);
          }
        });
        dadosExcel.push(formattedRow);
      });
      dadosExcel.push({ ITEM: 'Total Geral de Vendas no Período', ...{ '': this.formatCurrency(this.totalGeral) } });
      dadosExcel.push({});
    }

    if (this.exibirLucroPrevisto && this.valorSegundaTabela.length) {
      dadosExcel.push({ ITEM: 'Lucro Previsto no Período' });
      this.valorSegundaTabela.forEach((row) => {
        const formattedRow = { ...row };
        Object.keys(row).forEach((key) => {
          if (this.isCurrencyColumnSecond(key)) {
            formattedRow[key] = this.formatCurrency(row[key]);
          }
        });
        dadosExcel.push(formattedRow);
      });
      dadosExcel.push({ ITEM: 'Total de Lucro Previsto no Período', ...{ '': this.formatCurrency(this.totalKmGeral) } });
      dadosExcel.push({});
    }

    if (this.valorDadosBaixo.length) {
      dadosExcel.push({ ITEM: 'PORCENTUAL CLV' });
      dadosExcel.push(...this.valorDadosBaixo);
      dadosExcel.push({});
    }

    return dadosExcel;
  }

  private linhasRanking(): any[][] {
    const linhas: any[][] = [
      ['Maiores clientes'],
      ['Posição', 'Nome', 'Documento', 'Tipo', 'Total gasto'],
    ];

    this.ranking.forEach((cliente, index) => {
      linhas.push([
        index + 1,
        cliente.nome,
        this.formatarDocumentoRanking(cliente.documento, cliente.tipo),
        this.formatarTipoRanking(cliente.tipo),
        this.formatarTotalRanking(cliente.totalGasto),
      ]);
    });

    return linhas;
  }

  retornaDadosTelaAnterior() {
    this.route.queryParams.subscribe(params => {
      this.cpfCnpj = params.cpf;
      const cpfCnpjLimpo = this.removerMascara(this.cpfCnpj);

      const valorChassi = params.chassi;
      const valorDataIncRetorno = params.dataInicial;
      const valorDataFimRetorno = params.dataFinal;

      this.f.cpf.setValue(cpfCnpjLimpo);
      this.f.dataInc.setValue(valorDataIncRetorno);
      this.f.dataFim.setValue(valorDataFimRetorno);

      this.loading = true;
      if(valorChassi || cpfCnpjLimpo){
        this.veiculosClvService.getDados(valorDataIncRetorno, valorDataFimRetorno, valorChassi, cpfCnpjLimpo)
        .subscribe(
          (data) => {
            if (!data || data.length === 0) {
              this.messageService.add({
                key: 'tl',
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Não foram localizados dados para este CPF/CNPJ ou Chassi',
                life: 3000,
              });
              this.mostrarCaption = false;
              this.valorDados = [];
              this.valorSegundaTabela = [];
              this.valorDadosBaixo = [];
              this.columns = [];
              this.quantidadePorModelo = {};
              this.nomeCliente = '';
            } else {
              data.forEach(item => {
                item.chassiFormatado = this.chassi ? `CHASSI: ${this.chassi}` : '';
              });

              this.nomeCliente = data[0].dados[0].nome || '';

              this.primeiraTable(data);
              this.preencherLucroPrevisto(data);
              this.formatDataGridBaixo(data);

              this.mostrarCaption = true;
            }
            this.primeiraPesquisa = false;
          },
          (error) => {
            this.messageService.add({
              key: 'tl',
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao buscar os dados.',
              life: 3000,
            });
            this.nomeCliente = '';
            this.primeiraPesquisa = false;
          },
          () => {
            this.loading = false;
          }
        );
      }

    });
  }



}
